"use strict";

import * as React from 'react';
import { NavigationIndependentTreeContext } from "./NavigationIndependentTreeContext.js";
export function useNavigationIndependentTree() {
  return React.useContext(NavigationIndependentTreeContext);
}
//# sourceMappingURL=useNavigationIndependentTree.js.map